var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "library__card card",
      attrs: { href: _vm.decode(_vm.doc.url) }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card__title" }, [
        _vm._v("\n    " + _vm._s(_vm.doc.title) + "\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card__description" }, [
        _vm._v("\n    Uploaded on " + _vm._s(_vm.doc.created_time) + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__logo-container" }, [
      _c("div", { staticClass: "card__logo-wrapper" }, [
        _c("div", { staticClass: "card__logo h-center-align" }, [
          _c("span", {
            staticClass: "glyphicon glyphicon-file",
            attrs: { "aria-hidden": "true" }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }